import TextArea from 'antd/lib/input/TextArea'
import { doc_editContentById_Api } from 'apis'
import ApiInfoForm from 'components/form/ApiInfoForm'
import FieldDecorator from 'components/form/FieldDecorator'
import { SubmitButton } from 'components/form/FormActionBar'
import { createValue } from 'components/form/utils'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import { SelectWidget } from 'views/AppLocals/custom/ReactSelectComponents'
import { bindQueryParam } from 'views/AppLocals/functions/routerHelper'
import { deepTranslate } from 'views/Shared'
import { DocumentRowTypes } from '../components/DocumentDetail'

export const ParagraphEditForm = ({
  document_id,
  paragraph_id,
  paragraph_type,
  paragraph_value,
  onClose,
  renderPreview = (widget, paragraph_value) => widget,
}) => {
  const t = useTranslate()
  return (
    <ApiInfoForm
      disableNotify={false}
      onSuccess={() => {
        onClose()
      }}
      initialValues={{
        paragraph_id,
        paragraph_type,
        paragraph_value,
      }}
      apiInfo={doc_editContentById_Api}
      query={bindQueryParam({ id: document_id })}>
      {({
        isSubmitting,
        dirty,
        isValid,
        values = {},
        validate,
        handleChange,
        handleSubmit,
        ...props
      }) => (
        <div className="flex flex-col space-y-3">
          <FieldDecorator label="edit">
            <TextArea
              name="paragraph_value"
              placeholder={t('content')}
              defaultValue={paragraph_value}
              rows={5}
              onChange={(e) => {
                handleChange(createValue('paragraph_value', e.target.value))
              }}
            />
          </FieldDecorator>
          <FieldDecorator label="clause type">
            <SelectWidget
              className="w-full"
              defaultValue={paragraph_type}
              onChange={(value) => {
                handleChange(createValue('paragraph_type', value))
              }}
              placeholder={t('clause type')}
              options={Object.values(DocumentRowTypes).map(deepTranslate(t))}
            />
          </FieldDecorator>
          <div className="text-right py-3">
            <SubmitButton dirtyRequired={false} />
          </div>
        </div>
      )}
    </ApiInfoForm>
  )
}

export default ParagraphEditForm
